export const DEFAULT_PAGE_META = {
  title: "Helga Jakobs Immobilien | Immobilienmakler in Eschweiler",
  description:
    "Helga Jakobs Immobilien – Ihr Partner für Verkauf, Vermietung und Bewertung von Immobilien in Eschweiler und der Euregio.",
};

export const PAGE_METADATA = [
  {
    path: "/",
    title: "Helga Jakobs Immobilien | Immobilienmakler in Eschweiler",
    description:
      "Immobilienmaklerin Helga Jakobs bietet maßgeschneiderte Lösungen für Kauf, Verkauf und Vermietung in Eschweiler.",
  },
  {
    path: "/beratungstermin",
    title: "Beratungstermin vereinbaren | Helga Jakobs Immobilien",
    description:
      "Vereinbaren Sie Ihren persönlichen Beratungstermin mit Helga Jakobs Immobilien und lassen Sie sich individuell beraten.",
  },
  {
    path: "/vermieten",
    title: "Immobilie vermieten | Helga Jakobs Immobilien",
    description:
      "Unterstützung bei der Vermietung Ihrer Immobilie – von der Bewertung bis zur Mietersuche.",
  },
  {
    path: "/testing",
    title: "Motion Playground | Helga Jakobs Immobilien",
  },
  {
    path: "/immobilien",
    title: "Aktuelle Immobilienangebote | Helga Jakobs Immobilien",
    description:
      "Entdecken Sie aktuelle Immobilienangebote in Eschweiler und Umgebung. Finden Sie Ihr neues Zuhause oder Investment.",
  },
  {
    path: "/immobilien/suchprofil-anlegen",
    title: "Suchprofil anlegen | Helga Jakobs Immobilien",
    description:
      "Erstellen Sie Ihr persönliches Suchprofil und erhalten Sie neue Immobilienangebote zuerst.",
  },
  {
    path: "/immobilien/:type",
    title: "Immobilienangebote | Helga Jakobs Immobilien",
    description:
      "Spezialisierte Immobilienangebote von Helga Jakobs Immobilien – entdecken Sie passende Exposés.",
    exact: false,
  },
  {
    path: "/expose/:id",
    title: "Exposé | Helga Jakobs Immobilien",
    description:
      "Detaillierte Exposé-Ansicht einer Immobilie von Helga Jakobs Immobilien.",
    exact: false,
  },
  {
    path: "/ratgeber",
    title: "Immobilienratgeber | Helga Jakobs Immobilien",
    description:
      "Lesen Sie hilfreiche Artikel rund um Immobilienverkauf, Vermietung und Finanzierung.",
  },
  {
    path: "/ratgeber/:slug",
    title: "Ratgeber-Beitrag | Helga Jakobs Immobilien",
    description:
      "Ausführliche Ratgeberbeiträge von Helga Jakobs Immobilien zu aktuellen Immobilienthemen.",
    exact: false,
  },
  {
    path: "/bewerten",
    title: "Immobilienbewertung | Helga Jakobs Immobilien",
    description:
      "Erfahren Sie, wie viel Ihre Immobilie wert ist – Bewertung durch Helga Jakobs Immobilien.",
  },
  {
    path: "/bewerten/:type/online-bewertung",
    title: "Online-Immobilienbewertung | Helga Jakobs Immobilien",
    description:
      "Schnelle Online-Bewertung für Ihre Immobilie – kostenlos und unverbindlich.",
    exact: false,
  },
  {
    path: "/bewerten/:type",
    title: "Immobilienbewertung | Helga Jakobs Immobilien",
    description:
      "Individuelle Bewertungslösungen für Ihre Immobilie durch Helga Jakobs Immobilien.",
    exact: false,
  },
  {
    path: "/verkaufen",
    title: "Immobilie verkaufen | Helga Jakobs Immobilien",
    description:
      "Professioneller Verkauf Ihrer Immobilie mit Helga Jakobs Immobilien – von der Analyse bis zum Abschluss.",
  },
  {
    path: "/verkaufen/:type",
    title: "Immobilie verkaufen | Helga Jakobs Immobilien",
    description:
      "Spezialisierte Verkaufsleistungen von Helga Jakobs Immobilien für Ihr Objekt.",
    exact: false,
  },
  {
    path: "/unternehmen",
    title: "Unternehmen | Helga Jakobs Immobilien",
    description:
      "Erfahren Sie mehr über Helga Jakobs Immobilien und unser Team in Eschweiler.",
  },
  {
    path: "/unternehmen/über-uns",
    title: "Über uns | Helga Jakobs Immobilien",
    description:
      "Lernen Sie das Team und die Philosophie von Helga Jakobs Immobilien kennen.",
  },
  {
    path: "/unternehmen/kontakt",
    title: "Kontakt | Helga Jakobs Immobilien",
    description:
      "Kontaktieren Sie Helga Jakobs Immobilien – wir freuen uns auf Ihre Anfrage.",
  },
  {
    path: "/rechtliches",
    title: "Rechtliches | Helga Jakobs Immobilien",
    description:
      "Rechtliche Hinweise und Informationen zu Helga Jakobs Immobilien.",
  },
  {
    path: "/rechtliches/impressum",
    title: "Impressum | Helga Jakobs Immobilien",
    description:
      "Impressum und rechtliche Informationen zu Helga Jakobs Immobilien.",
  },
  {
    path: "/rechtliches/datenschutz",
    title: "Datenschutz | Helga Jakobs Immobilien",
    description:
      "Datenschutzerklärung von Helga Jakobs Immobilien – so gehen wir mit Ihren Daten um.",
  },
  {
    path: "/referenzen",
    title: "Referenzen | Helga Jakobs Immobilien",
    description:
      "Erfolgreiche Projekte und Kundenstimmen von Helga Jakobs Immobilien.",
  },
  {
    path: "/:citySlug",
    title: "Stadt | Helga Jakobs Immobilien",
    description:
      "Immobilienmakler-Service in Ihrer Stadt – professionell und persönlich.",
    exact: false,
    isDynamic: true,
  },
  {
    path: "*",
    title: "Seite nicht gefunden | Helga Jakobs Immobilien",
    description:
      "Die gewünschte Seite konnte nicht gefunden werden – zurück zur Startseite von Helga Jakobs Immobilien.",
    exact: false,
  },
];
